export enum FilterOperation {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  LIKE = 'LIKE',
  IN = 'IN',
  IS_NULL = 'IS_NULL',
  IS_NOT_NULL = 'IS_NOT_NULL',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  JSON_CONTAINS = 'JSON_CONTAINS',
}

export interface FilterCriteria<T> {
  field: keyof T & string;
  operation: FilterOperation;
  value?: string;
  values?: string[];
}
